import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { MobileDetectionService } from '../../services/mobile-detection.service';

@Component({
  selector: 'app-table-pattern1',
  templateUrl: './table-pattern1.component.html',
  styleUrls: ['./table-pattern1.component.scss']
})
export class TablePattern1Component implements OnInit {

  @Output() goToDetails = new EventEmitter<string>();
  @Output() onActionClickOutput = new EventEmitter<any>();
  @Output() onPageChangeEvent = new EventEmitter<any>();
  @Output() onPageNumberChange = new EventEmitter<any>();
  @Input() isDetailsPageShow: boolean = false;
  @Input() noOfColumnToShowOnModile = 3;
  @Input() tableDetails: ITableModel = {
    data: [
      {
        id: 4,
        name: 'Patricia Lebsack',
        email: 'Julianne.OConner@kory.org',
        passed: 'Yes',
        status: 'offline',
        phoneNumber: '9922556565'
      },
      {
        id: 5,
        name: 'Chelsey Dietrich',
        email: 'Lucio_Hettinger@annie.ca',
        passed: 'No',
        status: 'available',
      },
      {
        id: 6,
        name: 'Mrs. Dennis Schulist',
        email: 'Karley_Dach@jasper.info',
        passed: 'Yes',
        status: 'unavailable'
      },
      {
        id: 7,
        name: 'Kurtis Weissnat',
        email: 'Telly.Hoeger@billy.biz',
        passed: 'No',
        status: 'delivering'
      },
      {
        id: 8,
        name: 'Nicholas Runolfsdottir V',
        email: 'Sherwood@rosamond.me',
        passed: 'Yes',
      },
      {
        id: 9,
        name: 'Glenna Reichert',
        email: 'Chaim_McDermott@dana.io',
        passed: 'No',
      },
      {
        id: 10,
        name: 'Clementina DuBuque',
        email: 'Rey.Padberg@karina.biz',
        passed: 'No',
      },
      {
        id: 11,
        name: 'Nicholas DuBuque',
        email: 'Rey.Padberg@rosamond.biz',
        passed: 'Yes',
      },
    ],
    columnDetails: [
      { columnName: 'name', dataFieldName: '', divType: 'UserDetails' },
      { columnName: 'Status', dataFieldName: 'status', columnNo: 1, divType: 'status' },
      { columnName: 'phone', dataFieldName: 'status', columnNo: 1, divType: 'phoneIcon' },
      // {columnName:'PhoneNumber',dataFieldName:'phoneNumber',columnNo:1,divType:'',color:'#5C85FC'},
      { columnName: 'Email', dataFieldName: 'email', noOfValueDataField: [{ dataFieldName: 'name', }, { dataFieldName: 'email', color: '#5C85FC' }], divType: 'multiValueRow', columnNameIsShow: true, columnNo: 1 },
      { columnName: 'Email', dataFieldName: 'email', noOfValueDataField: [{ dataFieldName: 'name', }, { dataFieldName: 'email', color: '#5C85FC' }], divType: 'multiValueRow', columnNameIsShow: true, columnNo: 1 },
      { columnName: 'Passed', dataFieldName: 'passed', columnNo: 1, divType: '' },
      { columnName: 'Action', dataFieldName: '', divType: 'action' },
      { columnName: 'goTO', dataFieldName: '', divType: 'goTo' },
    ],
    actionList: []
  };
  isMobileView: boolean = false;
  selectedRowIndex: number;
  @Input() totalDataCount: number;
  @Input() selectedRowId: number = 0;
  constructor(
    private mobileDetectionService: MobileDetectionService,
  ) { }

  ngOnInit() {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    !this.selectedRowId ? this.selectedRowIndex = 1 : null;
    // this.tableDetails.actionList.map(x => {
    //   x.command = (event?: any) => this.onActionClick(event, event.item.label)

    // })

    console.log('ffff', this.tableDetails);
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.target instanceof HTMLElement && event.target.classList.contains('tableMainDiv')) {
      this.selectedRowIndex = !this.selectedRowIndex ? 1 : this.selectedRowIndex;
      if (event.key === 'ArrowUp' && this.selectedRowIndex > 0) {
        this.selectedRowIndex--;
      } else if (event.key === 'ArrowDown' && this.selectedRowIndex < this.tableDetails.data.length - 1) {
        this.selectedRowIndex++;
      } else if (event.key === 'Enter' && this.selectedRowIndex < this.tableDetails.data.length - 1) {
        this.goToDetails.emit(this.tableDetails.data[this.selectedRowIndex]);
        this.selectedRowId = this.tableDetails.data[this.selectedRowIndex].Id;
      }
    }
  }

  onGoToClick(row: any) {
    this.goToDetails.emit(row);
    this.selectedRowIndex = null;
  }

  onPageNumberChangeFn(event) {
    this.onPageNumberChange.emit(event);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  onActionClick(row, event, isDirectAction) {
    if (isDirectAction) {
      const actionName = event
      this.onActionClickOutput.emit({ row, actionName });
      return;
    }
    const actionName = event.target.innerText ? event.target.innerText : this.tableDetails.actionList[0].label;
    console.log(row, actionName);
    this.selectedRowIndex = null;
    this.onActionClickOutput.emit({ row, actionName });
  }

  onPageChange(pageNo) {
    this.selectedRowIndex = null;
    this.onPageChangeEvent.emit(pageNo);
  }

  openPhoneHyperLink(phone: any) {
    const phoneLink = "tel:+" + phone;
    window.location.href = phoneLink;
  }


}
